import { Toggle } from '@ps/web-shared-components';
import type { ChangeEvent } from 'react';
import React, { useEffect } from 'react';
import { useForm } from 'react-final-form';

import { TXTCLI_Select_All } from './SelectAllToggle.messages.json';

interface SelectAllToggleProps {
  checkboxes: string[];
  values: Record<string, boolean>;
}
const getIsSelectedAll = (values: Record<string, boolean>, checkboxes: string[]): boolean =>
  checkboxes.every((checkbox) => values[checkbox]);

const SelectAllToggle: React.FC<SelectAllToggleProps> = ({ checkboxes, values }) => {
  const isSelectedAll = getIsSelectedAll(values, checkboxes);

  const { change } = useForm();

  const handleSelectAll = (e: ChangeEvent<HTMLInputElement>) => {
    checkboxes.forEach((item) => {
      change(item, e.target.checked);
    });
  };

  useEffect(() => change('selectAll', isSelectedAll), [change, isSelectedAll]);

  return (
    <Toggle
      id="selectAll"
      name="selectAll"
      label={TXTCLI_Select_All}
      onChange={handleSelectAll}
      onOffToggle
      type="switch"
    />
  );
};

export default SelectAllToggle;
